export default {
    'diagram3': {
      'title': `<span>Analysis of Technology Alternatives</span>
                <br/><br/>Please drag and drop the elements of the problem definition into their correct positions in the framework`,
      'structure-answers-title': `Elements of the problem definition`,
      'situation-title': 'situation',
      'diagram-header': 'Bank operations',
      'situation-second-row': 'Unisys Clearpath Dorado mainframe',
      'left-box': 'CIF System',
      'right-box': 'Deposits System',
      'bottom-box-points': `
      <p>Maintains high level customer information and processing services</p>
      <p> - Costs $12 million/year</p>
      `,
      'situation-desc': 'DISTURBING EVENT'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5b/diagram3/i18n/en.js